/**
 * Runtime theme token helpers for charts / canvas / inline styles.
 * Prefer CSS vars from theme.css; fall back to dark-obsidian defaults.
 */

export function cssVar(name, fallback = '') {
  if (typeof document === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

/** Chart axis / legend / title text */
export function chartTextColor() {
  return cssVar('--chart-text', cssVar('--text-axis', 'rgba(245,247,250,0.64)'));
}

export function chartGridColor() {
  return cssVar('--chart-grid', 'rgba(255,255,255,0.055)');
}

export function chartTooltipTheme() {
  return {
    mode: 'index',
    intersect: false,
    backgroundColor: cssVar('--chart-tooltip-bg', 'rgba(8,10,14,0.96)'),
    titleColor: cssVar('--text-tooltip', '#F0F3FA'),
    bodyColor: cssVar('--text-tooltip', '#F0F3FA'),
    borderColor: cssVar('--chart-tooltip-border', 'rgba(0,240,255,0.22)'),
    borderWidth: 1,
    titleFont: { size: 10, weight: '600', family: cssVar('--font-sans', 'system-ui,sans-serif') },
    bodyFont: { size: 10, family: cssVar('--font-sans', 'system-ui,sans-serif') },
    padding: 8,
    cornerRadius: 3,
    displayColors: true,
  };
}

export function numPos() {
  return cssVar('--num-pos', cssVar('--green', '#00FF66'));
}

export function numNeg() {
  return cssVar('--num-neg', cssVar('--red', '#FF2D6A'));
}

export function textMain() {
  return cssVar('--text-main', '#F5F7FA');
}

export function textMuted() {
  return cssVar('--text-muted', 'rgba(245,247,250,0.80)');
}

export function textDim() {
  return cssVar('--text-dim', 'rgba(245,247,250,0.58)');
}

export function textLegend() {
  return cssVar('--text-legend', cssVar('--text-muted', 'rgba(245,247,250,0.78)'));
}

export function textPrice() {
  return cssVar('--text-price', '#F5F7FA');
}

export function monoStack() {
  return cssVar('--font-mono', 'ui-monospace,Consolas,monospace');
}
